const ESSEN_BEARBEITUNG = 2

const PRUFUNG = 5

const KREAKTIONRUCKTRITT = 6

const VERTRAGZUMKUNDEN = 9

const KREDITWIRDAUSBEZAHLT = 11

const NEGATIVESCHUFA = 12

const DIGITALERVERTRAG = 15

const MITANTRAGSTELLER = 19

const SALESFORCE = 20

const MSFFAHRTVERTRAG = 21

const PAPIERKORB = 40

const ALTERNATIVEBANKEN = 60

const FEHLER = 62

const VERTRAGABGELEHNT = 63

const SELBSTSTANDIGE = 65

const AUXMONEYANFRAGE = 66

const AUXMONEYINBEARBEITUNG = 67

const AUXMONEYQS = 68

const AUXMONEYVERTRAGERSTELLT = 69

const AUXMONEYAUSBEZAHLT = 70

const AUXMONEYABGELEHNT = 10118

const AUXMONEYFEHLER = 10119

const EGTSPEZIALISTEN = 71

const EGTKLARUNG = 73

const DOPPELT = 1017

const IMMO_ANDURATIOUBERGEBEN = 10060

const IMMO_AUSBEZAHLT = 10020

const NEGATIVER_SPEEDCHECK = 10062

const MITANTRAGSTELLER_ANFORDERN = 10101

const KEINE_REAKTION_21 = 10105

const POTENTIAL_SPAETER = 10116

const ESSEN_GENEHMIGT = 18

const VERTRAGSEINGANG = 10

const DMS = 1117

const SCHWEIZ_ABGELEHNT = 503

const SCHWEIZNEUANFRAGE = 74
const WOHNORTAUSLAND = 75
const POSTRUCKLAUFER = 80
const SCHWEIZANFAUSWEIS = 500
const SCHWEIZZUMHOCHLADEN = 501
const SCHWEIZINBEARBEITUNG = 502
const ONHOLD = 998
const QUARANTANE = 1005
const TEMPANGESTELLTE = 1006
const SCHULDENSANIERER = 1007
const POTENTIALNEARPRIME = 1008
const ESSENEGTWV = 1009
const UMSCHULDUNG2VERSUCH = 1010
const IMMO_NACHBEARBEITUNGDATEN = 10002
const IMMO_3ANGEBOT4UNTERLAGEN = 10005
const IMMO_9KREDITGENEHMIGT = 10009
const IMMO_EINGANGNEUANFRAGE = 10012
const IMMO_1POSITIVERSPEEDCHECK = 10018
const IMMO_VEBFEHLERMELDUNG = 10099
const IMMO_5PROFIPRUFUNGVEB = 10100
const IMMO_4UNTERLAGENUNVOLLSTANDIG = 10102
const IMMO_ABSAGEWIRDGEPRUFT = 10103
const IMMO_6UNTERLAGENVERVOLLSTANDIGEN = 10104
const IMMO_WIEDERVORLAGENACHPZ = 10106
const IMMO_10VERTRAGZUMKUNDEN = 10107
const IMMO_VERTRAGZURBANK = 10108
const IMMO_8UMGEWANDELTINECHTFALL = 10111
const IMMO_2ERSTGESPRACHKLARUNG = 10112
const IMMO_BAUFINANZIERUNG = 10114
const IMMO_7UNTERLAGENBEREIT = 10115
const MIT_LFZ_120_HOCHGELADEN = -20000
const MIT_WOHNHAFT_HOCHGELADEN = -20001
const MIT_HALBER_KREDITSUMME_HOCHGELADEN = -20002
const ConsorsHEKVorfilter = 10121
const IMMO_EP_PRUFUNG = 10122

const LASTSCHRIFT_AKTIVIERT = 10183

const SIGMA_LASTSCHRIFT_INKASSO = 10184

const SIGMA_AUSBEZAHLT = 10153

const SIGMA_LASTSCHRIFT_AKTIVIERT = 10183

const SIGMA_WIEDERVORLAGE = 10181

// Bestandskundenupload SIGMA (CRM: Status::SIGMA_BESTAND)
const SIGMA_BESTAND = 10203

const EINWANDBEHANDLUNG = 10204

const STATUS = {
  ESSEN_BEARBEITUNG,
  PRUFUNG,
  KREAKTIONRUCKTRITT,
  VERTRAGZUMKUNDEN,
  KREDITWIRDAUSBEZAHLT,
  NEGATIVESCHUFA,
  DIGITALERVERTRAG,
  MITANTRAGSTELLER,
  SALESFORCE,
  MSFFAHRTVERTRAG,
  ALTERNATIVEBANKEN,
  FEHLER,
  VERTRAGABGELEHNT,
  SELBSTSTANDIGE,
  AUXMONEYANFRAGE,
  AUXMONEYINBEARBEITUNG,
  AUXMONEYQS,
  AUXMONEYVERTRAGERSTELLT,
  AUXMONEYAUSBEZAHLT,
  EGTSPEZIALISTEN,
  EGTKLARUNG,
  DOPPELT,
  IMMO_ANDURATIOUBERGEBEN,
  IMMO_AUSBEZAHLT,
  NEGATIVER_SPEEDCHECK,
  MITANTRAGSTELLER_ANFORDERN,
  KEINE_REAKTION_21,
  POTENTIAL_SPAETER,
  ESSEN_GENEHMIGT,
  DMS,
  VERTRAGSEINGANG,
  PAPIERKORB,
  SCHWEIZ_ABGELEHNT,
  AUXMONEYABGELEHNT,
  AUXMONEYFEHLER,

  SCHWEIZNEUANFRAGE,
  WOHNORTAUSLAND,
  POSTRUCKLAUFER,
  SCHWEIZANFAUSWEIS,
  SCHWEIZZUMHOCHLADEN,
  SCHWEIZINBEARBEITUNG,
  ONHOLD,
  QUARANTANE,
  TEMPANGESTELLTE,
  SCHULDENSANIERER,
  POTENTIALNEARPRIME,
  ESSENEGTWV,
  UMSCHULDUNG2VERSUCH,
  IMMO_NACHBEARBEITUNGDATEN,
  IMMO_3ANGEBOT4UNTERLAGEN,
  IMMO_9KREDITGENEHMIGT,
  IMMO_EINGANGNEUANFRAGE,
  IMMO_1POSITIVERSPEEDCHECK,
  IMMO_VEBFEHLERMELDUNG,
  IMMO_5PROFIPRUFUNGVEB,
  IMMO_4UNTERLAGENUNVOLLSTANDIG,
  IMMO_ABSAGEWIRDGEPRUFT,
  IMMO_6UNTERLAGENVERVOLLSTANDIGEN,
  IMMO_WIEDERVORLAGENACHPZ,
  IMMO_10VERTRAGZUMKUNDEN,
  IMMO_VERTRAGZURBANK,
  IMMO_8UMGEWANDELTINECHTFALL,
  IMMO_2ERSTGESPRACHKLARUNG,
  IMMO_BAUFINANZIERUNG,
  IMMO_7UNTERLAGENBEREIT,
  MIT_LFZ_120_HOCHGELADEN,
  MIT_WOHNHAFT_HOCHGELADEN,
  MIT_HALBER_KREDITSUMME_HOCHGELADEN,
  ConsorsHEKVorfilter,
  IMMO_EP_PRUFUNG,
  LASTSCHRIFT_AKTIVIERT,
  SIGMA_LASTSCHRIFT_INKASSO,
  SIGMA_AUSBEZAHLT,
  SIGMA_LASTSCHRIFT_AKTIVIERT,
  SIGMA_WIEDERVORLAGE,
  SIGMA_BESTAND,
  EINWANDBEHANDLUNG
}

export {
  STATUS,
  ESSEN_BEARBEITUNG,
  PRUFUNG,
  KREAKTIONRUCKTRITT,
  VERTRAGZUMKUNDEN,
  KREDITWIRDAUSBEZAHLT,
  NEGATIVESCHUFA,
  DIGITALERVERTRAG,
  MITANTRAGSTELLER,
  SALESFORCE,
  MSFFAHRTVERTRAG,
  ALTERNATIVEBANKEN,
  FEHLER,
  VERTRAGABGELEHNT,
  SELBSTSTANDIGE,
  AUXMONEYANFRAGE,
  AUXMONEYINBEARBEITUNG,
  AUXMONEYQS,
  AUXMONEYVERTRAGERSTELLT,
  AUXMONEYAUSBEZAHLT,
  EGTSPEZIALISTEN,
  EGTKLARUNG,
  DOPPELT,
  PAPIERKORB,
  SCHWEIZ_ABGELEHNT,

  IMMO_ANDURATIOUBERGEBEN,
  IMMO_AUSBEZAHLT,
  NEGATIVER_SPEEDCHECK,
  MITANTRAGSTELLER_ANFORDERN,
  KEINE_REAKTION_21,
  POTENTIAL_SPAETER,
  ESSEN_GENEHMIGT,
  DMS,
  VERTRAGSEINGANG,
  AUXMONEYABGELEHNT,
  AUXMONEYFEHLER,

  SCHWEIZNEUANFRAGE,
  WOHNORTAUSLAND,
  POSTRUCKLAUFER,
  SCHWEIZANFAUSWEIS,
  SCHWEIZZUMHOCHLADEN,
  SCHWEIZINBEARBEITUNG,
  ONHOLD,
  QUARANTANE,
  TEMPANGESTELLTE,
  SCHULDENSANIERER,
  POTENTIALNEARPRIME,
  ESSENEGTWV,
  UMSCHULDUNG2VERSUCH,
  IMMO_NACHBEARBEITUNGDATEN,
  IMMO_3ANGEBOT4UNTERLAGEN,
  IMMO_9KREDITGENEHMIGT,
  IMMO_EINGANGNEUANFRAGE,
  IMMO_1POSITIVERSPEEDCHECK,
  IMMO_VEBFEHLERMELDUNG,
  IMMO_5PROFIPRUFUNGVEB,
  IMMO_4UNTERLAGENUNVOLLSTANDIG,
  IMMO_ABSAGEWIRDGEPRUFT,
  IMMO_6UNTERLAGENVERVOLLSTANDIGEN,
  IMMO_WIEDERVORLAGENACHPZ,
  IMMO_10VERTRAGZUMKUNDEN,
  IMMO_VERTRAGZURBANK,
  IMMO_8UMGEWANDELTINECHTFALL,
  IMMO_2ERSTGESPRACHKLARUNG,
  IMMO_BAUFINANZIERUNG,
  IMMO_7UNTERLAGENBEREIT,
  MIT_LFZ_120_HOCHGELADEN,
  MIT_WOHNHAFT_HOCHGELADEN,
  MIT_HALBER_KREDITSUMME_HOCHGELADEN,
  ConsorsHEKVorfilter,
  IMMO_EP_PRUFUNG,
  LASTSCHRIFT_AKTIVIERT,
  SIGMA_LASTSCHRIFT_INKASSO,
  SIGMA_AUSBEZAHLT,
  SIGMA_LASTSCHRIFT_AKTIVIERT,
  SIGMA_WIEDERVORLAGE,
  SIGMA_BESTAND,
  EINWANDBEHANDLUNG
}
